export default __webpack_public_path__ + "static/media/568.093517cf.gif";